import { capturePendingAuthAction, clearPendingAuthAction, type AuthResumeIntent } from "./authResume";
import { openAuthModal } from "./openAuthModal";
import { fetchSessionUser } from "./sessionUser";

type AuthResumeIntentInput = AuthResumeIntent | (() => AuthResumeIntent | Promise<AuthResumeIntent | undefined>);

export async function requireSignedIn(
  action: () => void | Promise<void>,
  intent?: AuthResumeIntentInput,
): Promise<void> {
  const user = await fetchSessionUser();
  if (!user?.email) {
    const resolved = typeof intent === "function" ? await intent() : intent;
    if (resolved) {
      capturePendingAuthAction(action, resolved);
    }
    openAuthModal({ mode: "signup" });
    return;
  }

  clearPendingAuthAction();
  await action();
}
